@if (commonService.isLoading) {
  <app-loading></app-loading>
}

<div class="general-block" theme>
    <div class="app-container">
      <div class="app-body">
        <mat-drawer-container autosize id="main-mat-drawer-container">
          <mat-drawer [mode]="isMobile ? 'over' : 'side'" 
                      [opened]="isMenuOpend" 
                      (openedChange)="isMenuOpend = $event"
                      class="side-container-class">
            <ng-container>
              <collapse-side-navigation
                #sideNavComp
                [ngClass]="isMenuOpend ? 'menu-class' : 'minimized-menu'"
                [expandSideNav]="isMobile ? true : isMenuOpend"
                [listMenu]="navigationMenu"
                [menuType]="'button'"
                (valueChange)="navigateToDetails($event)"
                (closeMenu)="isMenuOpend = false"
              >
              </collapse-side-navigation>
            </ng-container>
          </mat-drawer>
          <mat-drawer-content class="app-content">
            <!-- Overlay for mobile when menu is open -->
            @if(isMobile && isMenuOpend) {
                <div class="mobile-overlay" (click)="sideBarToggler()"></div>
            }
            <app-header
              (homeBtn)="redirectHome($event)"
              (toggleSidebarForMe)="sideBarToggler()"
              [ngClass]="isMenuOpend ? 'header-class' : 'minimized-header'"
            ></app-header>
            <div [ngClass]="!isMenuOpend ? 'margin-top-5' : ''" class="margin-container margin-continer-bottom">
              <router-outlet></router-outlet>
            </div>
          </mat-drawer-content>
        </mat-drawer-container>
        @if (hideFooter == false || hideFooter == undefined) {
          <app-footer id="footer-id" class="footer-container"></app-footer>
        }
      </div>
    </div>
</div>
